import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "d-flex align-items-center flex-grow-1 mb-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-45px me-5" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fa fa-user",
    style: {"font-size":"25px"}
  })
], -1)
const _hoisted_4 = { class: "d-flex flex-column ms-0" }
const _hoisted_5 = {
  key: 0,
  class: "fw-bold fs-4 me-1"
}
const _hoisted_6 = { class: "d-flex align-items-center gap-2 fs-sm-5" }
const _hoisted_7 = { style: {"font-size":"12px"} }
const _hoisted_8 = { style: {"font-size":"12px"} }
const _hoisted_9 = { style: {"font-size":"12px"} }
const _hoisted_10 = ["href"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-share text-info me-1",
  style: {"font-size":"15px"}
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("small", { style: {"font-size":"12px"} }, "Kunjungi", -1)
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1)
const _hoisted_15 = { class: "d-flex gap-2 ms-auto" }
const _hoisted_16 = { class: "d-flex flex-column" }
const _hoisted_17 = {
  key: 0,
  class: "me-1"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen text-white me-2" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "text-white" }, "Edit", -1)
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = { class: "d-flex mb-2" }
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = { class: "d-flex gap-3 mb-2" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { class: "d-flex gap-2" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "fs-5" }, "Followers:", -1)
const _hoisted_27 = { class: "fs-5 fw-bold" }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { class: "d-flex gap-2" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "fs-5" }, "View:", -1)
const _hoisted_31 = { class: "fs-5 fw-bold" }
const _hoisted_32 = { key: 2 }
const _hoisted_33 = { class: "d-flex gap-2" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "fs-5" }, "Like:", -1)
const _hoisted_35 = { class: "fs-5 fw-bold" }
const _hoisted_36 = { key: 3 }
const _hoisted_37 = { class: "d-flex gap-2" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", { class: "fs-5" }, "Komentar:", -1)
const _hoisted_39 = { class: "fs-5 fw-bold" }
const _hoisted_40 = { key: 4 }
const _hoisted_41 = { class: "d-flex gap-2" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", { class: "fs-5" }, "Favorite:", -1)
const _hoisted_43 = { class: "fs-5 fw-bold" }
const _hoisted_44 = { key: 5 }
const _hoisted_45 = { class: "d-flex gap-2" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", { class: "fs-5" }, "Favorite:", -1)
const _hoisted_47 = { class: "fs-5 fw-bold" }
const _hoisted_48 = { key: 6 }
const _hoisted_49 = { class: "d-flex gap-2" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("span", { class: "fs-5" }, "Quote:", -1)
const _hoisted_51 = { class: "fs-5 fw-bold" }
const _hoisted_52 = { key: 7 }
const _hoisted_53 = { class: "d-flex gap-2" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("span", { class: "fs-5" }, "Reply:", -1)
const _hoisted_55 = { class: "fs-5 fw-bold" }
const _hoisted_56 = { key: 8 }
const _hoisted_57 = { class: "d-flex gap-2" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("span", { class: "fs-5" }, "Retweet:", -1)
const _hoisted_59 = { class: "fs-5 fw-bold" }
const _hoisted_60 = { key: 9 }
const _hoisted_61 = { class: "d-flex gap-2" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("span", { class: "fs-5" }, "Repost:", -1)
const _hoisted_63 = { class: "fs-5 fw-bold" }
const _hoisted_64 = { key: 10 }
const _hoisted_65 = { class: "d-flex gap-2" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("span", { class: "fs-5" }, "Share:", -1)
const _hoisted_67 = { class: "fs-5 fw-bold" }
const _hoisted_68 = { class: "mb-2" }
const _hoisted_69 = { key: 0 }
const _hoisted_70 = { class: "d-flex gap-2" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("span", { class: "fs-5" }, " Tanggal Disimpan:", -1)
const _hoisted_72 = { class: "fs-5 fw-bold" }
const _hoisted_73 = { key: 1 }
const _hoisted_74 = { class: "d-flex gap-2" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("span", { class: "fs-5" }, "Diinput Oleh:", -1)
const _hoisted_76 = { class: "fs-5 fw-bold" }

import { ref } from 'vue';
import { useRouter } from "vue-router";
import { profileSource, getEmotion, getSentiment, formatDateIndo } from "@/global-helper/handler";

interface IProps {
  data: any;
}
export default /*#__PURE__*/_defineComponent({
  props: {
    data: { type: null, required: true }
  },
  setup(__props: any) {

const props = __props as {
  data: any;
}
;


const data = ref(props.data);
const router = useRouter();

const goToRoute = (id: string, name: string, detail: boolean) => {
  if (detail) {
    window.open("/berita/detail/" + id);
  } else {
    router.push({ name: name, params: { id: id } });
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        ('account' in data.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(data.value.account), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("i", {
            class: _normalizeClass(_unref(profileSource)(data.value.source).icon),
            style: _normalizeStyle(`color: ${_unref(profileSource)(data.value.source).color}; font-size: 15px`)
          }, null, 6),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(profileSource)(data.value.source).label), 1),
          _createElementVNode("i", {
            class: _normalizeClass(_unref(getSentiment)(data.value.sentiment).icon),
            style: {"font-size":"15px !important"}
          }, null, 2),
          _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(getSentiment)(data.value.sentiment).label), 1),
          _createElementVNode("i", {
            class: _normalizeClass(_unref(getEmotion)(data.value.emotion).icon),
            style: {"font-size":"15px !important"}
          }, null, 2),
          _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(getEmotion)(data.value.sentiment).label), 1),
          _createElementVNode("a", {
            href: data.value.url,
            target: "_blank",
            class: "text-info ml-1"
          }, _hoisted_13, 8, _hoisted_10)
        ])
      ]),
      _hoisted_14,
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          ('date' in data.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_17, "Publikasi " + _toDisplayString(_unref(formatDateIndo)(data.value.date)), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("button", {
          class: "btn btn-icon btn-bg-warning btn-active-color-warning btn-sm me-1",
          "data-bs-toggle": "tooltip",
          title: "Edit",
          style: {"width":"5rem"},
          onClick: _cache[0] || (_cache[0] = ($event: any) => (goToRoute(data.value._id, 'berita-edit-medsos', false)))
        }, _hoisted_20)
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("p", {
        innerHTML: data.value.content,
        class: "text-justify fs-5"
      }, null, 8, _hoisted_22)
    ]),
    _createElementVNode("div", _hoisted_23, [
      ('followers' in data.value && data.value.source !== 'review')
        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _createElementVNode("span", _hoisted_27, _toDisplayString(data.value.followers), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      ('view' in data.value.engagement_detail)
        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _createElementVNode("span", _hoisted_31, _toDisplayString(data.value.engagement_detail.view), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      ('like' in data.value.engagement_detail)
        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _hoisted_34,
              _createElementVNode("span", _hoisted_35, _toDisplayString(data.value.engagement_detail.like), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      ('comment' in data.value.engagement_detail)
        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _hoisted_38,
              _createElementVNode("span", _hoisted_39, _toDisplayString(data.value.engagement_detail.comment), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      ('favorite' in data.value.engagement_detail)
        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, [
              _hoisted_42,
              _createElementVNode("span", _hoisted_43, _toDisplayString(data.value.engagement_detail.favorite), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      ('fav' in data.value.engagement_detail)
        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
            _createElementVNode("div", _hoisted_45, [
              _hoisted_46,
              _createElementVNode("span", _hoisted_47, _toDisplayString(data.value.engagement_detail.fav), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      ('quote' in data.value.engagement_detail)
        ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
            _createElementVNode("div", _hoisted_49, [
              _hoisted_50,
              _createElementVNode("span", _hoisted_51, _toDisplayString(data.value.engagement_detail.quote), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      ('reply' in data.value.engagement_detail)
        ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
            _createElementVNode("div", _hoisted_53, [
              _hoisted_54,
              _createElementVNode("span", _hoisted_55, _toDisplayString(data.value.engagement_detail.reply), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      ('rt' in data.value.engagement_detail)
        ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
            _createElementVNode("div", _hoisted_57, [
              _hoisted_58,
              _createElementVNode("span", _hoisted_59, _toDisplayString(data.value.engagement_detail.rt), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      ('repost' in data.value.engagement_detail)
        ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
            _createElementVNode("div", _hoisted_61, [
              _hoisted_62,
              _createElementVNode("span", _hoisted_63, _toDisplayString(data.value.engagement_detail.repost), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      ('share' in data.value.engagement_detail)
        ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
            _createElementVNode("div", _hoisted_65, [
              _hoisted_66,
              _createElementVNode("span", _hoisted_67, _toDisplayString(data.value.engagement_detail.share), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_68, [
      ('created_at' in data.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
            _createElementVNode("div", _hoisted_70, [
              _hoisted_71,
              _createElementVNode("span", _hoisted_72, _toDisplayString(_unref(formatDateIndo)(data.value.created_at)), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      ('author' in data.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
            _createElementVNode("div", _hoisted_74, [
              _hoisted_75,
              _createElementVNode("span", _hoisted_76, _toDisplayString(data.value.author), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})